// extracted by css-extract-rspack-plugin
export default {"imagePreviewModalHeading":"g_lgS8O_pi4oDOrl","variationDisplay":"PQn_fcJX0xAQvCAU","imageWrapper":"C94pM66hUtmpoiCt","image":"VDJBRdxyXvAiU1Nt"};